import React, { Component } from "react";
import '../InitialForm/InitialFormStyleSheet.css';
import Select from 'react-select';
import { s360ConfigService } from "../Services/S360Config";
class Dropdown extends Component {

    constructor(props) {
        super(props);
        this.messageRef = React.createRef();
    }

    render() {
        let optionsArray = []
        this.props && this.props.item.options && this.props.item.options.map(eachOption => { optionsArray.push({ value: eachOption, label: eachOption }) })
        return (
            <div className="s360-initial-form-dropdown-container" style={this.formInputBoxContainerStyle()} >
                <div className="s360-initial-form-dropdown-label">
                    {this.props.item.label}
                </div>
                <div className="s360-initial-form-dropdown-option" style={this.formInputBoxStyle()}>
                    <Select options={optionsArray} captureMenuScroll={false} isSearchable={false} styles={this.selectOptionsStyle} onChange={this.onSelectOption} />
                </div>
            </div>
        );
    }

    selectedOption = null;
    onSelectOption = (selectedOption) => {
        this.selectedOption = selectedOption.value;
    }

    formInputBoxContainerStyle = () => {
        return {
            color: s360ConfigService.config.designDetails.headerColor,
        }
    }

    formInputBoxStyle = () => {
        return {
            borderColor: s360ConfigService.config.designDetails.headerColor,
            backgroundColor: s360ConfigService.config.designDetails.pageBackgroundColor

        }
    }

    value = () => {
        if (!this.selectedOption) { return {} ; }
        let aValue = {};
        aValue[this.props.item.label] = this.selectedOption; 
        return aValue;
    };

    validate = () => { 
        let formItemDetails = this.props.item || {};
        let isRequired = formItemDetails.required || formItemDetails.primaryField;
        return !(isRequired && !this.selectedOption);
    }

    validationErrorMessage = () => {
        return "Please select " + this.props.item.label.toLowerCase() + ".";
    }

    selectOptionsStyle = {
        control: (provided, state) => ({
            ...provided,
            border: '2px solid' + s360ConfigService.config.designDetails.headerColor,
            boxShadow: 'none',
            borderRadius: '0px',
            color: s360ConfigService.config.designDetails.headerColor,
            width: '100% !important',
            // // height: 35,
            // minHeight: 34,
            border: state.isFocused ? '1px solid ' : '1px solid '+ s360ConfigService.config.designDetails.headerColor,
            // This line disable the blue border
            boxShadow: state.isFocused ? '1px solid ' + s360ConfigService.config.designDetails.headerColor : '1px solid ' + s360ConfigService.config.designDetails.headerColor,
            '&:hover': {
                border: state.isFocused ? '1px solid ' + s360ConfigService.config.designDetails.headerColor : '1px solid ' + s360ConfigService.config.designDetails.headerColor
            }
        }),
        singleValue: (provided, state) => ({
            ...provided,
            // width: "68%",
            color: s360ConfigService.config.designDetails.headerColor,
        }),
        option: (styles, { data, isDisabled, isFocused, isSelected }) => {
            const color = s360ConfigService.config.designDetails.headerColor;
            return {
                ...styles,
                backgroundColor: isDisabled
                    ? null
                    : isSelected
                        ? color
                        // : isFocused
                        //     ? color
                            : null,
                ':active': {
                    ...styles[':active'],
                    backgroundColor: null,
                },
                borderBottom: '1px solid #ccc',
            };
        },
    };


}


export default Dropdown;